import { styled } from '@mui/material/styles';

interface StyledActionButtonProps {
  themeColor?: string;
  chatSize?: string;
}

const StyledActionButton = styled('p')<StyledActionButtonProps>`
  margin: 0;
  border: 1px solid
    ${props => (props.themeColor as string) || 'rgb(23, 65, 255)'};
  color: ${props => (props.themeColor as string) || 'rgb(23, 65, 255)'};
  font-size: ${props => {
    switch (props.chatSize) {
      case 'small':
        return '14px';
      case 'large':
        return '18px';
      case 'medium':
      default:
        return '16px';
    }
  }};
  padding: 6px 14px;
  border-radius: 50px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  width: fit-content;
`;

export default StyledActionButton;
